module.exports = new __parcel__URL__("14c73713-e4df-4dba-933b-057feeac8dd1.39c23619.woff2").toString();